import { StaffControllerApi, StaffProfessionControllerApi } from '../api/generated';
import type { StaffProfessionResponse, StaffResponse } from '../api/generated';
import { createApiConfiguration } from '../api/apiConfig';

export async function fetchStaff(locationId: string): Promise<StaffResponse[]> {
  const api = new StaffControllerApi(createApiConfiguration());
  const response = await api.listStaff({ locationId });
  return response.data;
}

export async function fetchStaffCompetences(): Promise<StaffProfessionResponse[]> {
  const api = new StaffProfessionControllerApi(createApiConfiguration());
  const response = await api.listStaffProfessions({});
  return response.data;
}
